
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqy_45ifxp93xNzZBpT07N2yYja4zmWg_HyBZg0URDW3Ka0Meta } from "/codebuild/output/src570006657/src/src/pages/faq.vue?macro=true";
import { default as menutvL01f_45dJ_45Ao1p2uQScWXioGMPDdX6FPyetmrgLkciEMeta } from "/codebuild/output/src570006657/src/src/pages/menu.vue?macro=true";
import { default as index_kC7naq7xrUREHOyqu1rNrdd9Wn7IgyiZbDdT_fbJvcMeta } from "/codebuild/output/src570006657/src/src/pages/index.vue?macro=true";
import { default as contactbC6txuQ7b8E7LyuahPtJ25_45F2eKhm_45_rWvJOijnnAzkMeta } from "/codebuild/output/src570006657/src/src/pages/contact.vue?macro=true";
import { default as tutorialRkXucNBv8tHh2cPrSMVzSRVvtzF1NR04ubiCnfaUxnsMeta } from "/codebuild/output/src570006657/src/src/pages/tutorial.vue?macro=true";
import { default as agreement_cMfGUYCJDmq_45xrVx_W1MSUt1uPGDJWM_KbGREbLB14Meta } from "/codebuild/output/src570006657/src/src/pages/agreement.vue?macro=true";
import { default as about_45passQH1F6gaEXUCjpdV4P79RarPwuxkV6IHY4qSOq6_45iJf0Meta } from "/codebuild/output/src570006657/src/src/pages/about-pass.vue?macro=true";
import { default as index2qWAfz7w8bNVmZotzZn9o9087ZdLBJDKn9VsNhbqUFsMeta } from "/codebuild/output/src570006657/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Ue3zfoowQ_ADlH_45WzxMWcVaPmnLotiWM20h4oHKHeBEMeta } from "/codebuild/output/src570006657/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancezUdl0dtFuCOdKo_45Vio8oPLEemCJqF5D7tuaMhG3SxZ4Meta } from "/codebuild/output/src570006657/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93wJJTnxe4j57758LimTTBtkTwCB8euLAqN5aqE6y5RKsMeta } from "/codebuild/output/src570006657/src/src/pages/notice/[id].vue?macro=true";
import { default as indexoKNqnHnFjfW4fo7wulLg2Q6gF0ZySP3Sip1NYs1aOB0Meta } from "/codebuild/output/src570006657/src/src/pages/coupon/index.vue?macro=true";
import { default as indexJdJJadbLQuTF94iFNu7yo_UMM7S_45U1_45F_45nLS42yppyEMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/index.vue?macro=true";
import { default as indexRg_45yFYqGv6_45092ROyCz8c8A7S9JNtnMAezMYzFhOhIoMeta } from "/codebuild/output/src570006657/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93pKICqXmrY_45LCSwG8mtpFFLSAcU2FqUzGqBelp8jXWOYMeta } from "/codebuild/output/src570006657/src/src/pages/parking/[id].vue?macro=true";
import { default as index8Yhnx3WjYjizK8hfOKqnZQgE_6bPVwRANnJ0z_45OfLFkMeta } from "/codebuild/output/src570006657/src/src/pages/history/index.vue?macro=true";
import { default as indexTh7owzVkCPg7_45FpPgsfYNQBAqFTlYc_WgWcb59D1S8kMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/index.vue?macro=true";
import { default as indexmIX7_45Qhp_454fkp7b60hRWUUJyru4KEhP7ku2X5seoTEYMeta } from "/codebuild/output/src570006657/src/src/pages/sign-in/index.vue?macro=true";
import { default as index8OqdJGFP6uQ2_fXD2b9PMuiK_45IQhXj6IdqAvF9iH2LgMeta } from "/codebuild/output/src570006657/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavierr6y0Vzwi3XZMolSj4n2RZg_45uJ6cOvHeEO8NxWSzckMeta } from "/codebuild/output/src570006657/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editS7BXW87nwcJOath5pzAD0ycPNWDt89OljsGDYmpxxcAMeta } from "/codebuild/output/src570006657/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement4T54pMr3BjkWkbQNcda0_45E7cka_45KX7BYGgyKQYp4QzoMeta } from "/codebuild/output/src570006657/src/src/pages/pass-agreement.vue?macro=true";
import { default as index3yjhbGrqs8Uxad1t1D1nhWO3szZtbnTw1q4UtWaCn2oMeta } from "/codebuild/output/src570006657/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dKKxcogmHA0LrGlC186soex72N9A5GlPyR8yy7YEUn1EMeta } from "/codebuild/output/src570006657/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmqSyBMt4_45HA1kln5LntLkOsgQqEK6NxgsfSXoYrqClHAMeta } from "/codebuild/output/src570006657/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index4nHtPTdL9cLAIOPVrwOXEZTLnkC_xiVU7zE5kbP9mUYMeta } from "/codebuild/output/src570006657/src/src/pages/card/create/index.vue?macro=true";
import { default as index7JEUVB2Do942ppdAxAgVYrwvizCdrBIIXCF912JwMaYMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmYMap92IURa8qbakBoXTLJoQjMJLXpDSoJaSfhosusKwMeta } from "/codebuild/output/src570006657/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmt3uUkBkFNGUErc8_45TrUMomML9oNeOd9rR2LDn1w3_bcMeta } from "/codebuild/output/src570006657/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completesqkag23O3vQG_457UUaZr8Wp1oGQ2ZaHRVuK5p4RompIQMeta } from "/codebuild/output/src570006657/src/src/pages/membership/complete.vue?macro=true";
import { default as registerTLvjdMDqJIo6utoBWLsCrQknWV9lOk0W8QDKU7sTkbMMeta } from "/codebuild/output/src570006657/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_935m9Zzo1C_SgwPwujvGtWzpMdOlwGGMnjzFTIwzk_ASoMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmqK46naimuwiW9P_fFzNArnzjwhee_4569nhwsIslIeIRcMeta } from "/codebuild/output/src570006657/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93KfYw_45Wntgcbvwx1YE40gdOEyZAOeOuXX4jcMG0FcPfkMeta } from "/codebuild/output/src570006657/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexCHJFIJJaEsgK8VkteqvrtKBevZx1T1V2DTCNB3V4yOMMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codestBk9pBe4YCz62OkVzvr8jEURll_fw2b50CifnWRXr4Meta } from "/codebuild/output/src570006657/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codej7AmoSTPzn566HD7_45bBHkK1uTR3lzpP0NJqbHbzNcr0Meta } from "/codebuild/output/src570006657/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeiKSEP_JCfV5v8EY9fheuxcWLgjNMir6VOQZ0Blyd3dsMeta } from "/codebuild/output/src570006657/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerVDvzJC08WVyAAcSq9e7RUuxecE_EUInZRp4XtVRAFd4Meta } from "/codebuild/output/src570006657/src/src/pages/contact-form/register.vue?macro=true";
import { default as completep9msYKLiQqeCWQ72meBbRvz28R5dw1CN2g8VzSnVoYEMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index003if_IrHd10M97oZojw2vpg487rcJFf37frGxXkWcoMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmKg4U6_ZSb8NAuEkp3lYI9gNULApafYBuzRiJGR_7b0YMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completevG7A39kRrvXYp67Zo1EzfA7nXJ6SGwo4MnCnw7TqGxkMeta } from "/codebuild/output/src570006657/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexghPgcI20QQANWgyZ0CboyQMhKqzuZ9UFTWJwUOmAsRQMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93j6eIYA4Mj5nNm8WtzhHXW3i3QIs9PaIUBnUo8OxYymYMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completex25ocl_45qzGQud914J3oyFrTnC1RBdYD64GHlmDzfHrYMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasopP02bzHyK7pjGVYAWIhxlE_rRzjeSEeXyO_45woj3REMMeta } from "/codebuild/output/src570006657/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleRYwrO7FHU_45QcgKjAFZBE0batS21j1yzTcO816CIVrKgMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailo6VE5spG3nZBMs6NYXtPGjOtqYoVgmu0sijL0N_apo8Meta } from "/codebuild/output/src570006657/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmuV4wTEdnzypeRCvu8hDRhec1HcFE91mhlQ8_wVrygCsMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentHuD_452x0VpPG4iSmWAQKQ5Uh353LjJp19EwMt2US_lcIMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmQpKAbCM_MnqnTXzq9fNqWmxxWHXRwd2vz8JfeOrVvHgMeta } from "/codebuild/output/src570006657/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatesWfNBg_IOHbpetwn6t7KgWB4S1n04RtgqUsF4QPS4RYMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete1YxrYPGYJCc1m_EpcfpAq2dwqyIoINZY_RjB1UyUVVAMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeKFg3BeKMhOLJUP1Ymz7ynIZ_45I2YvDrTjaNREyeT4PugMeta } from "/codebuild/output/src570006657/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordetNhuqPoU6i9782s8JGmcX8J1FAsWIf5JqpaVJ_45bpvcMeta } from "/codebuild/output/src570006657/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasqCdcWpHlZZEOCK8hnjpMibh_45UWLxo9BW89W_xRcpwQMMeta } from "/codebuild/output/src570006657/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerX_wCyxXsVTW3vZGBynTCtrJqGYMyFx4Y7dPio2z47kAMeta } from "/codebuild/output/src570006657/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeNujjLFczCZQCNYsrCWrFm0IyKosUf_457zXFgY2cDnVLIMeta } from "/codebuild/output/src570006657/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexew9wUQbAmKFGMmAvynsw_45NegGj6Sjebvk_45XEyy7zRtkMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index5hSMwVM7v_SG5tiEWCrHwwP3IQmlRI_45Aobm7PyjW4u4Meta } from "/codebuild/output/src570006657/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexRFeT6rbDNTgSYDSNx2bGpzDLLvFt1nsUNUSNK3PNqRQMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexNZHbD4zYAuJ4aM2LmbonCPpBGp2F_45EhvXe8zXSlSC9IMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateJNhfLeekRNgWgQfBdHjnTJVHT41kOEtq5QconNNryDEMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete7y_45tJpmZL2YUKsJ60T2WQQj9vwD_45AZee4Xv2sZRCNw4Meta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmIkpuqdZpxTIut9gy419te7GjyVJCEd8FRKBTh85suQ8Meta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexkwGu1NSPLpNaa83ExoAeTfaWy4fOiFF2_bdchSH_OpAMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeU8AnNeEclND2Aajm95sKifSerYCcJHP6cpcpwk_45m_YcMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatei_m1dg3LfdgbIcqgY4Hx11Natc9YYkdMeb3ZfN0v7uAMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexuJCTNtTHi5gBDDsyGQ6_BOgaJ66WYwXGehtMbySjo0kMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexDhb2N3MFU_3UZASamuTtI2VPFZW5tShv3ZX_DcRj2xYMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completez8GPK8oF_45V2ceAl4Wq5JGnGh_kHM6d5fAu8Zf0MvYDgMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexu4EVMTxShd4Z2m7dShYKjC0tObtWqUSFamImlWqbQxwMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeJPr4kqMwO0UY8sBcDzZ8sgAREW2wy1Wu7y3xyHP_45cxoMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indextrw44N_45LielEElyoRgSPo9o8_6AdzgVt_45fvLI0FiA4EMeta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexZjRgULdu4ylw8xFWup1RR_45X75Ggc2ck6UqQZ42OLOocMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexSJdJOhr_45W56BxIwZdid4t9a1qwyc6w6c0bSRdnkjCqsMeta } from "/codebuild/output/src570006657/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateO_PWpDN7CqnhROSgziJEfCDRQDoRQfK8_45p2LaVHE8W0Meta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmtU0XdKUeng991rxtvn5Ht0DP7Ix9h0Y5_45npfS0qowf8Meta } from "/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src570006657/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menutvL01f_45dJ_45Ao1p2uQScWXioGMPDdX6FPyetmrgLkciEMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index_kC7naq7xrUREHOyqu1rNrdd9Wn7IgyiZbDdT_fbJvcMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src570006657/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src570006657/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src570006657/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src570006657/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src570006657/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexoKNqnHnFjfW4fo7wulLg2Q6gF0ZySP3Sip1NYs1aOB0Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src570006657/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src570006657/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index8Yhnx3WjYjizK8hfOKqnZQgE_6bPVwRANnJ0z_45OfLFkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexmIX7_45Qhp_454fkp7b60hRWUUJyru4KEhP7ku2X5seoTEYMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index8OqdJGFP6uQ2_fXD2b9PMuiK_45IQhXj6IdqAvF9iH2LgMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src570006657/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src570006657/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index4nHtPTdL9cLAIOPVrwOXEZTLnkC_xiVU7zE5kbP9mUYMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmYMap92IURa8qbakBoXTLJoQjMJLXpDSoJaSfhosusKwMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmt3uUkBkFNGUErc8_45TrUMomML9oNeOd9rR2LDn1w3_bcMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completesqkag23O3vQG_457UUaZr8Wp1oGQ2ZaHRVuK5p4RompIQMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerTLvjdMDqJIo6utoBWLsCrQknWV9lOk0W8QDKU7sTkbMMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmqK46naimuwiW9P_fFzNArnzjwhee_4569nhwsIslIeIRcMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codestBk9pBe4YCz62OkVzvr8jEURll_fw2b50CifnWRXr4Meta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codej7AmoSTPzn566HD7_45bBHkK1uTR3lzpP0NJqbHbzNcr0Meta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeiKSEP_JCfV5v8EY9fheuxcWLgjNMir6VOQZ0Blyd3dsMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerVDvzJC08WVyAAcSq9e7RUuxecE_EUInZRp4XtVRAFd4Meta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmKg4U6_ZSb8NAuEkp3lYI9gNULApafYBuzRiJGR_7b0YMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completevG7A39kRrvXYp67Zo1EzfA7nXJ6SGwo4MnCnw7TqGxkMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexghPgcI20QQANWgyZ0CboyQMhKqzuZ9UFTWJwUOmAsRQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completex25ocl_45qzGQud914J3oyFrTnC1RBdYD64GHlmDzfHrYMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleRYwrO7FHU_45QcgKjAFZBE0batS21j1yzTcO816CIVrKgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailo6VE5spG3nZBMs6NYXtPGjOtqYoVgmu0sijL0N_apo8Meta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmuV4wTEdnzypeRCvu8hDRhec1HcFE91mhlQ8_wVrygCsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentHuD_452x0VpPG4iSmWAQKQ5Uh353LjJp19EwMt2US_lcIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmQpKAbCM_MnqnTXzq9fNqWmxxWHXRwd2vz8JfeOrVvHgMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete1YxrYPGYJCc1m_EpcfpAq2dwqyIoINZY_RjB1UyUVVAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeKFg3BeKMhOLJUP1Ymz7ynIZ_45I2YvDrTjaNREyeT4PugMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordetNhuqPoU6i9782s8JGmcX8J1FAsWIf5JqpaVJ_45bpvcMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src570006657/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerX_wCyxXsVTW3vZGBynTCtrJqGYMyFx4Y7dPio2z47kAMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeNujjLFczCZQCNYsrCWrFm0IyKosUf_457zXFgY2cDnVLIMeta || {},
    component: () => import("/codebuild/output/src570006657/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src570006657/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src570006657/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]